export { THEME_META } from './themes.js';

// DEMO_DATA_REMOVED — THEME_POETS removed; theme poets now come from /api/poems/browse
// POET_EN_MAP kept as a fallback romanisation cache for poems where poetEn is null in DB.
// To fully remove: populate poetEn on all Poem rows in Supabase, then delete this map.

// English poet names for DB poems that lack a stored poetEn
export const POET_EN_MAP = {
  'أبو العلاء المعري':  'Al-Maʿarrī',
  'أبو الطيب المتنبي':  'Al-Mutanabbī',
  'أبو نواس':            'Abū Nuwās',
  'البحتري':             'Al-Buḥturī',
  'ابن خفاجة':          'Ibn Khafāja',
  'الصنوبري':           'Al-Ṣanawbarī',
  'أبو تمام':            'Abū Tammām',
  'الخنساء':             'Al-Khansāʾ',
  'أبو العتاهية':        'Abū al-ʿAtāhiya',
  'ابن الرومي':          'Ibn al-Rūmī',
  'الفرزدق':            'Al-Farazdaq',
  'جرير':               'Jarīr',
  'الحطيئة':            'Al-Ḥuṭayʾa',
  'الأخطل':             'Al-Akhṭal',
  'النابغة الذبياني':    'Al-Nābigha al-Dhubyānī',
  'كعب بن زهير':        'Kaʿb ibn Zuhayr',
  'ابن زيدون':          'Ibn Zaydūn',
  'العباس بن الأحنف':   'Al-ʿAbbās ibn al-Aḥnaf',
  'زهير بن أبي سلمى':  'Zuhayr ibn Abī Sulmā',
  'لبيد بن ربيعة':      'Labīd ibn Rabīʿa',
  'عنترة بن شداد':      'ʿAntarah ibn Shaddād',
  'عمرو بن كلثوم':     'ʿAmr ibn Kulthūm',
  'امرؤ القيس':         "Imruʾ al-Qays",
  'طرفة بن العبد':      'Ṭarafa ibn al-ʿAbd',
  'الحارث بن حلزة':    'Al-Ḥārith ibn Ḥilliza',
  'ابن الفارض':         'Ibn al-Fāriḍ',
  'الحلاج':             'Al-Ḥallāj',
  'ابن عربي':           'Ibn ʿArabī',
  'قيس بن الملوح':      'Qays ibn al-Mulawwaḥ',
  'عمر بن أبي ربيعة':  'ʿUmar ibn Abī Rabīʿa',
  'جميل بثينة':         'Jamīl Buthayna',
  'كثير عزة':           'Kuthayyir ʿAzza',
  // poets present in the database
  'المتنبي':              'Al-Mutanabbī',
  'أبو فراس الحمداني':  'Abū Firās al-Ḥamdānī',
  'أحمد شوقي':           'Aḥmad Shawqī',
  'إيليا ابو ماضي':     'Ilyā Abū Māḍī',
  'ابو العتاهية':        'Abū al-ʿAtāhiya',
  'ابو نواس':            'Abū Nuwās',
  'الأعشى':              'Al-Aʿshā',
  'الإمام الشافعي':      'Al-Imām al-Shāfiʿī',
  'بدر شاكر السياب':    'Badr Shākir al-Sayyāb',
  'بشار بن برد':         'Bashshār ibn Burd',
  'محمود حسن اسماعيل':  'Maḥmūd Ḥasan Ismāʿīl',
  'نزار قباني':          'Nizzār Qabbānī',
  'ولادة بنت المستكفي': 'Wallāda bint al-Mustakfī',
};

// Canonical display order for AllPaths
export const THEME_ORDER = [
  'hikma', 'ghazal', 'sufi', 'fakhr', 'ritha',
  'zuhd', 'wasf', 'madih', 'karam', 'hija', 'muallaqat', 'shawq',
];

